import React, { useState, useEffect } from 'react';

export default function AnimatedLetterSwitcher() {
  const [showZ, setShowZ] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => setShowZ((z) => !z), 1500);
    return () => clearInterval(timer);
  }, []);

  return <span className='sz-switcher'>{showZ ? 'Z' : 'S'}</span>;
}
